import { createRoot } from 'react-dom/client';
import { setupBrowserObservability } from './observability.js';
import './styles/globals.css';
import { App } from './App.js';

// Observability is a no-op without SENTRY_DSN / OTEL_EXPORTER_OTLP_ENDPOINT,
// so this is free in dev. Fire-and-forget — never block startup on it.
// Installs window.error + unhandledrejection + pagehide handlers.
void setupBrowserObservability();

// Dev-only guard against the renderer crash: React's dev build logs a
// User Timing measure per component render and Chrome retains them until
// the buffer alone OOMs the renderer. See userTimingDrain.ts for the RCA.
if (import.meta.env.DEV) {
  void import('./dev/userTimingDrain.js').then(({ startUserTimingDrain }) =>
    startUserTimingDrain(),
  );
}

// Default to dark mode — see docs/07-art/direction.md.
document.documentElement.classList.add('dark');

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

// Dev-only prefab gallery (?prefabs). The DEV guard is statically false in
// production builds, so Vite drops the branch and the gallery chunk.
if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('prefabs')) {
  void import('./dev/PrefabGallery.js').then(({ PrefabGallery }) => {
    createRoot(root).render(<PrefabGallery />);
  });
} else if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('debugTile')) {
  // Tile inspector — one hex + neighbours through the real render pipeline.
  // See debug/TileDebug.tsx.
  void import('./debug/TileDebug.js').then(({ TileDebug }) => {
    createRoot(root).render(<TileDebug />);
  });
} else if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('debugWater')) {
  // Shoreline/wave diorama — one coast tile + wall in isolation with the
  // real water material. See debug/WaterDebugDiorama.tsx.
  void import('./debug/WaterDebugDiorama.js').then(({ WaterDebugDiorama }) => {
    createRoot(root).render(<WaterDebugDiorama />);
  });
} else {
  createRoot(root).render(<App />);
}
